import React from 'react';
import BudgetContext from './budgets/BudgetContext';
import ChangeRequestContext from './changeRequests/ChangeRequestContext';
import useFeatureToggle from 'framework/featureToggle';
import { Features } from 'infrastructure/featureToggle';
import WasteContext from '../finance/waste/WasteContext';
import BillingContext from './billing/BillingContext';

const FinanceLayout = () => {
  const { isFeatureEnabled } = useFeatureToggle();
  const isChangeRequestEnabled = isFeatureEnabled(Features.NEW_PROJECT_CHANGE_REQUEST);
  const isWasteEnabled = isFeatureEnabled(Features.NEW_PROJECT_WASTE);
  const isBillingEnabled = isFeatureEnabled(Features.NEW_PROJECT_BILLING);
  return (
    <>
      <BudgetContext />
      {isBillingEnabled && <BillingContext />}
      {isChangeRequestEnabled && <ChangeRequestContext />}
      {isWasteEnabled && <WasteContext />}
    </>
  );
};
export default FinanceLayout;
